/**
 * Function to replace the parameter placeholder in the Mssg text.
 *
 * @author Micha Krapp
 * @since v0.10.0 - 10.02.2017
 */

function resolveParameter ( textValue, parameters ){

    var returnText = textValue;

    if ( parameters != undefined ) {
        let placeholderBegin = '{';
        let placeholderEnd = '}';

        var currentKey;
        for ( currentKey in parameters ) {
            returnText = returnText.replace( placeholderBegin + currentKey + placeholderEnd, parameters[ currentKey ] );
        }
    }
    return returnText;
}
module.exports = resolveParameter;



// WEBPACK FOOTER //
// ./js/caseconfigurator/components/i18n/resolveParameter.js